exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}.intervalSelector{display:flex}.intervalSelector__item{width:80px;font-size:15px;text-align:center;color:#757575;cursor:pointer;padding:5px 0;border-top:1px solid #969696;border-bottom:1px solid #969696;border-right:1px solid #969696}.intervalSelector__item.active{cursor:default;background-color:#5750c5;color:#fff}.intervalSelector__item:first-child{border-top-left-radius:10px;border-bottom-left-radius:10px;border-left:1px solid #969696}.intervalSelector__item:last-child{border-top-right-radius:10px;border-bottom-right-radius:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/components/search_console/partials/intervalSelector.scss
// module id = 931
// module chunks = 0